import { Component, computed, signal } from '@angular/core';

import { PaginationRequest, SortingRequest } from '@rp/shared/models';
import { ObjectUtils } from '@rp/utils';

import { BaseTablePageComponent } from './base-table-page.component';
import { IconName } from '../../icon';

@Component({
  template: '',
})
export abstract class FilterTablePageBaseComponent<
  T extends object = Record<string, unknown>,
> extends BaseTablePageComponent {
  icons = IconName;

  defaultFilter = signal<T>({} as T);
  filter = signal<T>(this.defaultFilter());

  appliedFilter = computed(() => {
    const stripedFilter = ObjectUtils.stripEmptyFields(this.filter(), true);

    return Object.keys(stripedFilter).length;
  });

  override params = computed(() =>
    ObjectUtils.objectToQueryString(
      {
        ...this.adapter.toRest(this.filter(), this._pagination(), this.sorting()),
      },
      this.arrayKey(),
    ),
  );

  abstract adapter: {
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    toRest(filter: T, pagination: PaginationRequest, sorting: SortingRequest): any;
  };

  handleFilterChanged(filter: T): void {
    this._resetPaginationToDefaultPage();

    this.filter.set(filter);

    this._getData();
  }
}
